
import React, { ReactElement } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';

import { ModuleDeclaration } from '../ModuleDeclaration';

import EditPromptChain from './EditPromptChain/EditPromptChain';
import PromptChainList from './PromptChainList/PromptChainList';
import ViewPromptChain from './ViewPromptChain/ViewPromptChain';

const PromptContainer = (props: any): JSX.Element => {
  const element = withAuthenticationRequired(Outlet)(props);
  return element! as ReactElement;
};

const PromptChainsProperties: ModuleDeclaration = {
  routeProps: {
    path: '/prompt-chains',
    element: <PromptContainer />,
    children: [
      { index: true, element: <PromptChainList /> },
      { path: '/prompt-chains/edit/:id', element: <EditPromptChain /> },
      { path: '/prompt-chains/view/:id', element: <ViewPromptChain /> },
    ],
  },
  name: 'Prompt Chains',
  isHidden: false,
  containerCss: 'p-5 mb-5 border-bottom container-fluid',
  iconClassName: 'bi bi-magic',
};

export default PromptChainsProperties;
